import { rhymeKey, syllables } from "@/lib/poetry/dict";

const WORD = /[A-Za-z’'][A-Za-z’']*/g;
export const isHeader = (t) => /^\s*\[[^\]]{1,40}\]\s*$/.test(t);

export const countLine = (t) => (t.match(WORD) || []).reduce((a, w) => a + syllables(w), 0);
export const lastWord = (t) => { const m = t.match(WORD); return m ? m[m.length - 1] : ""; };

export const docLines = (doc) => {
  const out = [];
  doc.descendants((node, pos) => {
    if (!node.isTextblock) return true;
    if (out.length) out.push({ text: "", start: pos, end: pos, header: false });
    let text = "";
    let start = pos + 1;
    const flush = (end) => { out.push({ text, start, end, header: isHeader(text) }); text = ""; };
    node.forEach((child, off) => {
      if (child.type.name === "hardBreak") { flush(pos + 1 + off); start = pos + 2 + off; } else if (child.isText) text += child.text;
    });
    flush(pos + node.nodeSize - 1);
    return false;
  });
  return out;
};

const LETTERS = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";

export const analyse = (lines) => {
  const keys = new Map();
  let section = null;
  return lines.map((l) => {
    if (l.header) { section = l.text.replace(/[[\]\d]/g, "").trim().toLowerCase(); return { ...l, section }; }
    if (!l.text.trim()) return { ...l, blank: true, section };
    const key = rhymeKey(lastWord(l.text));
    if (key && !keys.has(key)) keys.set(key, LETTERS[keys.size % 26]);
    return { ...l, syl: countLine(l.text), letter: key ? keys.get(key) : "", section };
  });
};
